var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNoReservations(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-name": "placeholder no content",
    viewBox: "0 0 362 175",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0 0h362v175H0z",
    transform: "translate(502 267)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#8b8b8b",
    d: "M17597-2785.422a2.777 2.777 0 0 1-2.777-2.773 2.706 2.706 0 0 1 .119-.8 2.772 2.772 0 0 1-.592-.269 2.767 2.767 0 0 1-.932-3.807l2.924-4.783-28.932-24.938-22.818 35.413a2.783 2.783 0 0 1-2.385 1.338 2.781 2.781 0 0 1-1.432-.4 2.763 2.763 0 0 1-.937-3.8l31.855-51.042c.7-1.493 2.92-1.546 2.92-1.546a2.765 2.765 0 0 1 2.414 1.409 2.734 2.734 0 0 1-.035 2.791l-6.283 10.382h44.2l7.85-12.851a2.788 2.788 0 0 1 3.818-.923 2.765 2.765 0 0 1 .932 3.806l-7.2 11.79 14.795 37.209a2.769 2.769 0 0 1-.287 2.579 2.776 2.776 0 0 1-2.295 1.214zm30.82-5.542-11.738-29.533-18.043 29.533zm-29.15-11.69 12.252-20.054h-35.522z",
    "data-name": "Trac\\xE9 190",
    transform: "translate(-17538.832 2842.83)"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0 0h54v54.167H0z",
    "data-name": "Rectangle 198"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "b",
    x1: 0.5,
    x2: 0.5,
    y1: 0.07,
    y2: 0.919,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#d4e9f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f8f8f8"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)",
    "data-name": "Groupe de masques 25",
    transform: "translate(-502 -267)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "url(#b)",
    d: "M152 0h58a152 152 0 0 1 152 152H0A152 152 0 0 1 152 0z",
    "data-name": "bg card",
    transform: "translate(502 289)"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "park sign"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M695 317h7v124h-7z",
    "data-name": "Rectangle 196"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#b1b1b1",
    d: "M695 317h7v7h-7z",
    "data-name": "Rectangle 197"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 184",
    transform: "translate(670.684 267)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#c7c7c7",
    d: "M11.063 0h33.19a11.063 11.063 0 0 1 11.063 11.063v33.19a11.063 11.063 0 0 1-11.063 11.063h-33.19A11.063 11.063 0 0 1 0 44.253v-33.19A11.063 11.063 0 0 1 11.063 0z",
    "data-name": "Rectangle 196"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 45,
    height: 45,
    fill: "#1a4988",
    "data-name": "Rectangle 195",
    rx: 6,
    transform: "translate(5.316 5)"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M11.063 5.029a6.034 6.034 0 0 0-6.034 6.034v33.19a6.034 6.034 0 0 0 6.034 6.034h33.19a6.034 6.034 0 0 0 6.034-6.034v-33.19a6.034 6.034 0 0 0-6.034-6.034h-33.19m0-4.023h33.19a10.069 10.069 0 0 1 10.053 10.057v33.19a10.069 10.069 0 0 1-10.053 10.053h-33.19A10.069 10.069 0 0 1 1.006 44.253v-33.19A10.069 10.069 0 0 1 11.063 1.006z",
    "data-name": "Rectangle 195 - Contour"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M25.377 26.982v-6.887h3.926a10.582 10.582 0 0 1 1.674.129 3.894 3.894 0 0 1 1.416.5 2.718 2.718 0 0 1 .982 1.046 3.676 3.676 0 0 1 .37 1.77 3.676 3.676 0 0 1-.37 1.77 2.718 2.718 0 0 1-.982 1.046 3.894 3.894 0 0 1-1.416.5 10.582 10.582 0 0 1-1.674.129zm-5.053-10.814v22.979h5.053v-8.239h5.31a9.571 9.571 0 0 0 3.669-.628 6.864 6.864 0 0 0 2.46-1.657 6.346 6.346 0 0 0 1.384-2.366 8.739 8.739 0 0 0 .434-2.72 8.691 8.691 0 0 0-.434-2.736 6.367 6.367 0 0 0-1.384-2.348 6.864 6.864 0 0 0-2.46-1.657 9.571 9.571 0 0 0-3.669-.628z",
    "data-name": "Trac\\xE9 197"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    d: "M709.852 440.35v-21.045l-5.467 20.327a.65.65 0 0 1-.8.458.648.648 0 0 1-.459-.793l5.469-20.342-10.562 18.236a.657.657 0 0 1-.895.238.649.649 0 0 1-.238-.89l10.563-18.235-14.939 14.89a.648.648 0 0 1-.92 0 .649.649 0 0 1 0-.921l14.943-14.893-18.3 10.534a.66.66 0 0 1-.893-.238.654.654 0 0 1 .238-.89l18.291-10.527-20.4 5.45a.653.653 0 0 1-.8-.463.651.651 0 0 1 .459-.793l20.41-5.451h-21.125a.657.657 0 0 1-.656-.652.656.656 0 0 1 .656-.648h21.131l-20.41-5.452a.65.65 0 0 1-.461-.8.652.652 0 0 1 .795-.458l20.414 5.452-18.3-10.533a.649.649 0 0 1-.238-.886.653.653 0 0 1 .893-.238l18.3 10.534-14.945-14.9a.649.649 0 0 1 0-.921.656.656 0 0 1 .92 0l14.943 14.895-10.566-18.239a.647.647 0 0 1 .238-.886.657.657 0 0 1 .895.234l10.561 18.235-5.467-20.337a.648.648 0 0 1 .459-.8.654.654 0 0 1 .8.463l5.467 20.325v-21.043a.651.651 0 0 1 .654-.652.648.648 0 0 1 .648.652v21.078l5.475-20.36a.646.646 0 0 1 .795-.458.648.648 0 0 1 .465.793l-5.467 20.334 10.561-18.232a.66.66 0 0 1 .893-.238.651.651 0 0 1 .238.89l-10.564 18.241 14.943-14.892a.646.646 0 0 1 .918 0 .644.644 0 0 1 0 .917l-14.939 14.89 18.3-10.527a.653.653 0 0 1 .893.238.646.646 0 0 1-.24.886l-18.3 10.532 20.41-5.451a.654.654 0 0 1 .8.458.653.653 0 0 1-.463.8l-20.41 5.452h21.133a.651.651 0 0 1 .652.648.652.652 0 0 1-.652.652H715.47l20.41 5.451a.648.648 0 0 1 .459.793.65.65 0 0 1-.795.463l-20.41-5.451 18.295 10.528a.646.646 0 0 1 .24.89.657.657 0 0 1-.889.238l-18.3-10.529 14.936 14.888a.656.656 0 0 1 0 .921.646.646 0 0 1-.918 0l-14.943-14.894 10.564 18.243a.644.644 0 0 1-.238.886.648.648 0 0 1-.889-.238l-10.568-18.242 5.471 20.344a.656.656 0 0 1-.465.8.652.652 0 0 1-.795-.458l-5.475-20.36v21.078a.647.647 0 0 1-.648.648.651.651 0 0 1-.66-.647z",
    "data-name": "Trac\\xE9 192"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    d: "M802.272 440.361v-20.669l-5.367 19.964a.64.64 0 0 1-.781.454.639.639 0 0 1-.451-.785l5.363-19.952-10.363 17.89a.647.647 0 0 1-.877.234.637.637 0 0 1-.234-.873l10.363-17.891-14.656 14.608a.647.647 0 0 1-.906 0 .634.634 0 0 1 0-.9l14.664-14.614-17.961 10.335a.645.645 0 0 1-.875-.234.638.638 0 0 1 .238-.873l17.959-10.334-20.033 5.351a.638.638 0 0 1-.783-.449.64.64 0 0 1 .451-.785l20.02-5.345h-20.721a.642.642 0 0 1-.643-.639.642.642 0 0 1 .643-.639h20.736l-20.031-5.35a.637.637 0 0 1-.455-.78.642.642 0 0 1 .787-.449l20.02 5.346-17.949-10.33a.637.637 0 0 1-.234-.873.642.642 0 0 1 .875-.233l17.957 10.333-14.664-14.616a.629.629 0 0 1 0-.9.635.635 0 0 1 .9 0l14.664 14.614-10.367-17.9a.636.636 0 0 1 .234-.873.647.647 0 0 1 .877.233l10.365 17.894-5.365-19.961a.632.632 0 0 1 .451-.78.639.639 0 0 1 .781.449l5.367 19.97v-20.671a.641.641 0 0 1 .637-.639.64.64 0 0 1 .641.639v20.671l5.367-19.97a.646.646 0 0 1 .789-.449.635.635 0 0 1 .449.78l-5.367 19.967 10.367-17.9a.64.64 0 0 1 .871-.233.636.636 0 0 1 .24.873l-10.363 17.891 14.654-14.608a.642.642 0 0 1 .908 0 .641.641 0 0 1 0 .9l-14.656 14.608 17.949-10.329a.644.644 0 0 1 .875.233.645.645 0 0 1-.238.873l-17.955 10.331 20.027-5.347a.641.641 0 0 1 .785.449.636.636 0 0 1-.453.78l-20.027 5.35h20.736a.64.64 0 0 1 .641.639.64.64 0 0 1-.641.639h-20.725l20.016 5.345a.647.647 0 0 1 .457.785.64.64 0 0 1-.783.449l-20.033-5.351 17.959 10.334a.639.639 0 0 1 .234.873.644.644 0 0 1-.875.234l-17.955-10.332 14.662 14.61a.641.641 0 0 1 0 .9.65.65 0 0 1-.908 0L805.9 418.721l10.365 17.9a.639.639 0 0 1-.236.873.643.643 0 0 1-.875-.234l-10.371-17.9 5.367 19.967a.636.636 0 0 1-.451.78.64.64 0 0 1-.783-.449l-5.367-19.97v20.675a.64.64 0 0 1-.641.639.641.641 0 0 1-.636-.641z",
    "data-name": "Trac\\xE9 217"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 182",
    transform: "translate(683.766 359)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#383838",
    d: "m67.183 46.264 3.467-1.995 8.315 14.354-3.467 1.995z",
    "data-name": "Trac\\xE9 218"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.73,
    height: 12.059,
    fill: "#383838",
    "data-name": "Rectangle 178",
    rx: 1.865,
    transform: "rotate(-90 55.864 -7.867)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.239 34.192a21.134 21.134 0 1 0 14.993 36.078 21.134 21.134 0 0 0-14.993-36.078m0-5.539a26.673 26.673 0 1 1-26.761 26.673 26.717 26.717 0 0 1 26.761-26.673z",
    "data-name": "Ellipse 14"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M26.761 34.192A21.134 21.134 0 1 0 41.754 70.27a21.134 21.134 0 0 0-14.993-36.078m0-5.539A26.673 26.673 0 1 1 0 55.326a26.717 26.717 0 0 1 26.761-26.673z",
    "data-name": "Ellipse 13"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M81.955 58.404a2.777 2.777 0 0 1-2.777-2.773 2.706 2.706 0 0 1 .119-.8 2.772 2.772 0 0 1-.592-.269 2.767 2.767 0 0 1-.932-3.807l2.924-4.783-28.932-24.938-22.818 35.413a2.783 2.783 0 0 1-2.385 1.338 2.781 2.781 0 0 1-1.432-.4 2.763 2.763 0 0 1-.937-3.8L56.048 2.543c.7-1.493 2.92-1.546 2.92-1.546a2.765 2.765 0 0 1 2.414 1.409 2.734 2.734 0 0 1-.035 2.791l-6.283 10.382h44.2l7.85-12.851a2.788 2.788 0 0 1 3.818-.923 2.765 2.765 0 0 1 .932 3.806l-7.2 11.79 14.795 37.209a2.769 2.769 0 0 1-.287 2.579 2.776 2.776 0 0 1-2.295 1.214zm30.82-5.542-11.738-29.533-18.043 29.533zm-29.15-11.69 12.252-20.054H60.355z",
    "data-name": "Trac\\xE9 188"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.215 6.537H93.224a2.774 2.774 0 0 1-2.779-2.769c0-1.529 1.153-1.643 1.777-1.772l22.993-2c1.535 0 2.779 2.238 2.779 3.767a2.774 2.774 0 0 1-2.779 2.774zm-56.247-.001H40.981a2.77 2.77 0 1 1 0-5.539h17.987a2.77 2.77 0 1 1 0 5.539z",
    "data-name": "Trac\\xE9 50"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M75.824 48.99a8 8 0 1 1-8.028 8 8.015 8.015 0 0 1 8.028-8z",
    "data-name": "Ellipse 15"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m85.179 68.952-3.467 1.995-9.03-15.587 3.468-1.995z",
    "data-name": "Trac\\xE9 219"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.73,
    height: 12.059,
    "data-name": "Rectangle 176",
    rx: 1.865,
    transform: "rotate(90 10.534 78.384)"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)",
    "data-name": "Groupe de masques 22",
    transform: "translate(707.553 359.996)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#eb6400",
    d: "M60.987 12.809 21.821 9.931l-1.937 6.635L33.82 27.145l8.791-4.217z",
    "data-name": "Trac\\xE9 189"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#c6c6c6",
    d: "M744.382 382.779c.592-.678-.22-2.147-2.196-3.86l-2.54-2.201-3.774 2.681 1.985 1.726 1.04-.75.562.49.254 1.867 2.183 1.898-.364-2.227c1.293.762 2.339.962 2.85.376zm-2.857-3.011c.717.623.944 1.047.745 1.276-.265.305-.95.027-1.758-.673l-.717-.623.934-.671zm4.531 8.563c2.494 2.161 5.088 2.903 6.056 1.792.787-.905-.113-2.804-2.245-4.65-2.463-2.134-5.092-2.899-6.059-1.791-.792.908.117 2.801 2.248 4.648zm.843-.7c-1.036-.9-1.393-1.76-.967-2.24.493-.568 1.76-.373 3.096.784 1.036.9 1.393 1.76.967 2.24-.496.568-1.76.373-3.097-.784zm10.25 10.21 1.179-4.936-2.316-2.013-6.372.441 2.172 1.888 1.022-.109 2.517 2.182-.23.796zm-1.128-5.045.044.038-.409 1.424-1.477-1.284zm5.114 2.54-3.775 2.683 2.343 2.03c2.75 2.382 5.188 3.21 6.215 2.032.81-.932-.154-2.736-2.439-4.716zm-.876 3.76 1.95-1.39.463.403c1.17 1.016 1.536 1.773 1.127 2.243-.531.611-1.618.41-3.076-.853z",
    "data-name": "Trac\\xE9 191"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M710.624 393.106a21.044 21.044 0 0 0-19.377 12.8 20.877 20.877 0 0 0 4.505 22.96 21.063 21.063 0 0 0 34.245-6.66 20.877 20.877 0 0 0-4.5-22.961 20.992 20.992 0 0 0-14.873-6.139m0-3a23.949 23.949 0 1 1-24.027 23.949 23.988 23.988 0 0 1 24.027-23.949z",
    "data-name": "Ellipse 60"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M802.729 393.106a21.044 21.044 0 0 0-19.377 12.8 20.877 20.877 0 0 0 4.505 22.96 21.063 21.063 0 0 0 34.245-6.66 20.877 20.877 0 0 0-4.5-22.961 20.992 20.992 0 0 0-14.873-6.139m0-3a23.949 23.949 0 1 1-24.027 23.949 23.988 23.988 0 0 1 24.027-23.949z",
    "data-name": "Ellipse 61"
  }), /*#__PURE__*/React.createElement("g", {
    "data-name": "urban + helmet",
    transform: "translate(369.355 29.311)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Groupe 183"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#1c1c1c",
    d: "M244.292 332.57a1.243 1.243 0 0 1 .492 1.023l.232 6.131 1.722 9.61c.608.115-10.375-1.7-10.375-1.7l6.127-8.156.052.04-.233-5.986a1.235 1.235 0 0 1 1.976-.961zm-3.748 15.208a4.388 4.388 0 0 0 3.804.85l-1.052-6.1-3.504 4.665.494.372a3.23 3.23 0 0 0 .258.213z",
    "data-name": "Trac\\xE9 195"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#f292cd",
    d: "M245.91 342.223a4.345 4.345 0 0 1 1.991-.726 4.59 4.59 0 0 1 2.855.444 3.454 3.454 0 0 1 1.71 2.678l.392 2.791a9.168 9.168 0 0 1-.268 4.297c-1.189 3.808-4.633 5.462-7.315 6.178l-.217-1.548a1.081 1.081 0 1 0-2.14.3l.236 1.684-.282.04q-.297.042-.605.078c-.33.038-.665.07-.996.096l-.219-1.553a1.081 1.081 0 1 0-2.14.3l.186 1.317c-5.013-.13-7.503-2.248-8.71-4.003a8.358 8.358 0 0 1-1.433-3.816l-.393-2.792s1.527-.7 9.38-1.318c7.584-.78 5.812-2.47 7.968-4.447z",
    "data-name": "Trac\\xE9 196"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#454545",
    d: "m241.394 389.401-3.461-2.004 8.305-14.43 3.462 2.005z",
    "data-name": "Trac\\xE9 215"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.749,
    height: 12.045,
    fill: "#454545",
    "data-name": "Rectangle 192",
    rx: 1.875,
    transform: "rotate(-90 308.909 67.805)"
  }), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    "data-name": "Groupe de masques 23",
    transform: "translate(172.63 357.893)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    d: "m19.516 52.35 6.369-23.872-17.41 17.48-.708-.708 17.41-17.477-23.79 6.397-.259-.97 23.794-6.396-23.798-6.392.259-.966 23.795 6.387L7.756 8.363l.708-.71L25.88 25.117 19.5 1.255l.967-.26 6.383 23.862L33.214.99l.966.258-6.365 23.866 17.416-17.47.706.707-17.41 17.481L52.32 19.43l.26.965-23.793 6.408 23.796 6.387-.258.966-23.797-6.387 17.423 17.465-.708.71-17.422-17.467 6.383 23.86-.964.26-6.39-23.86-6.368 23.872z",
    "data-name": "Trac\\xE9 213"
  })), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d)",
    "data-name": "Groupe de masques 24",
    transform: "translate(257.847 358.264)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#d7d7d7",
    d: "m33.68 52.487-6.791-23.754-5.96 23.972-.969-.243 5.96-23.97L8.807 46.262l-.72-.697L25.201 27.79 1.518 34.603l-.276-.961 23.68-6.811-23.897-5.983.241-.974 23.896 5.978L7.446 8.689l.695-.72L25.86 25.134l-6.793-23.75.961-.276 6.79 23.748L32.776.883l.97.243L27.794 25.1 44.905 7.326l.72.694-17.11 17.773 23.68-6.81.276.96-23.68 6.812 23.9 5.981-.241.975-23.902-5.98 17.718 17.166-.696.72L27.852 28.45l6.79 23.753z",
    "data-name": "Trac\\xE9 214"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M199.63 363.279A21.664 21.664 0 0 0 178 384.977a21.63 21.63 0 1 0 36.925-15.343 21.455 21.455 0 0 0-15.295-6.355m0-5.015A26.713 26.713 0 1 1 173 384.977a26.671 26.671 0 0 1 26.63-26.713z",
    "data-name": "Ellipse 19"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M284.846 363.279a21.664 21.664 0 0 0-21.63 21.698 21.63 21.63 0 1 0 36.925-15.343 21.455 21.455 0 0 0-15.295-6.355m0-5.015a26.713 26.713 0 1 1-26.63 26.713 26.671 26.671 0 0 1 26.63-26.713z",
    "data-name": "Ellipse 20"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M232.583 389.151a2.51 2.51 0 0 1-.4-.032l-33.03-3.655a2.509 2.509 0 0 1-1.874-3.529l14.833-33.636a2.501 2.501 0 1 1 4.538 2.105l-13.446 30.629 29.771 3.131a2.509 2.509 0 0 1-.392 4.984z",
    "data-name": "Trac\\xE9 58"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#495fd6",
    d: "m282.489 384.67-21.982-34.238a44.6 44.6 0 0 1-2.133 10.111 26.288 26.288 0 0 1-6.316 10.589 21.9 21.9 0 0 1-11.078 5.762 33.331 33.331 0 0 1-5.992.637l1.531 2.568a2.5 2.5 0 0 1-.865 3.437 2.488 2.488 0 0 1-1.277.357 2.5 2.5 0 0 1-2.148-1.224l-3.8-6.378v-.005l-19.693-33.047a2.511 2.511 0 0 1 .859-3.441 2.5 2.5 0 0 1 3.43.867L232 372.506c4.242.09 11.291.221 16.566-4.959 4.8-4.714 7.234-11.958 7.234-23.518a2.54 2.54 0 0 1 .115-.755l-14.074-21.922a2.515 2.515 0 0 1-.059-2.542 2.494 2.494 0 0 1 2.184-1.287l1.488 1 41.295 63.5a2.516 2.516 0 0 1-.811 3.454 2.455 2.455 0 0 1-1.314.375 2.5 2.5 0 0 1-2.135-1.182z",
    "data-name": "Trac\\xE9 212"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M222.699 343.908h-15.431a2.5 2.5 0 0 1-2.5-2.508c0-1.385.029-4.016 1.409-4.016l16.521 1.508a2.508 2.508 0 0 1 0 5.015z",
    "data-name": "Trac\\xE9 62"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M210.873 355.885h-27.568a2.508 2.508 0 0 1 0-5.015h27.568a2.508 2.508 0 0 1 0 5.015z",
    "data-name": "Trac\\xE9 63"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M291.833 354.264h-17.395a2.5 2.5 0 0 1-2.164-1.252l-10.657-18.485h-19.733a2.508 2.508 0 0 1 0-5.015h49.949a2.5 2.5 0 0 1 2.5 2.508v19.737a2.5 2.5 0 0 1-2.5 2.507z",
    "data-name": "Trac\\xE9 64"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M258.311 323.09h-14.966a2.784 2.784 0 0 1 0-5.568h14.966a2.784 2.784 0 0 1 0 5.568z",
    "data-name": "Trac\\xE9 50"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "M239.575 378.678a8.014 8.014 0 1 1-7.989 8.014 8 8 0 0 1 7.989-8.014z",
    "data-name": "Ellipse 21"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2b2b2b",
    d: "m239.725 384.15 3.462 2.004-9.019 15.668-3.461-2.004z",
    "data-name": "Trac\\xE9 216"
  }), /*#__PURE__*/React.createElement("rect", {
    width: 3.749,
    height: 12.045,
    fill: "#2b2b2b",
    "data-name": "Rectangle 194",
    rx: 1.875,
    transform: "rotate(90 -79.848 318.864)"
  })), /*#__PURE__*/React.createElement("path", {
    fill: "#a4b0b5",
    d: "M719.323 441v-10.261a4.1 4.1 0 0 0-4.1-4.095h-23.549a4.094 4.094 0 0 0-4.095 4.095V441h-5.119v-10.261a9.222 9.222 0 0 1 9.214-9.213h23.549a9.224 9.224 0 0 1 9.214 9.213V441zm-47.73 0v-10a4 4 0 0 0-4-4h-23a4 4 0 0 0-4 4v10h-5v-10a9.012 9.012 0 0 1 9-9h23a9.012 9.012 0 0 1 9 9v10z"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoReservations);
export default __webpack_public_path__ + "static/media/no-reservations.f60940457f8d481e94d1cbb74d43abea.svg";
export { ForwardRef as ReactComponent };